export const MIN_VALIDITY = 10;
